import { AVAILABLE_PERIODS, DEFAULT_PERIOD_MONTHS } from '@shared/pricing';

/** localStorage key for persisting basket state. */
export const BASKET_STORAGE_KEY = 'bv-basket';

/** Default AVCS license period in months. */
export const DEFAULT_LICENSE_PERIOD_MONTHS = DEFAULT_PERIOD_MONTHS;

/** Available license period options (re-exported from shared pricing). */
export const LICENSE_PERIOD_OPTIONS = AVAILABLE_PERIODS;
